import { observer } from "mobx-react";
import React from "react";
import {
  generatePath,
  NavLink,
  useParams,
  useRouteMatch,
} from "react-router-dom";

import { Flex } from "@/components/Elements";
import CommentsSlideMenu from "@/components/table/shared/comments/CommentsSlideMenu";
import { useMainStore } from "@/contexts/Store";

import { ROUTES } from "../pages";
import ModuleTabs from "./ModuleTabs/ModuleTabs";

type PartnerTabsProps = {
  recordVersionId: string;
};

function PartnerTabs(props: PartnerTabsProps) {
  const mainStore = useMainStore();
  const { workspace_id } = useParams<{ workspace_id: string }>();
  const basePath = `${ROUTES.BASE_PATH}/${props.recordVersionId}`;
  const isPartnerInfoMatch = Boolean(
    useRouteMatch({ path: basePath, exact: true }),
  );
  const recordVersion =
    isPartnerInfoMatch &&
    mainStore.recordVersions.list.find(
      (rv) => rv.id === Number(props.recordVersionId),
    );

  return (
    <Flex alignCenter justifySpaceBetween fullWidth>
      <ModuleTabs>
        <NavLink
          exact
          to={generatePath(ROUTES.PARTNERS_DETAILS_EDIT_PATH, {
            record_version_id: props.recordVersionId,
            workspace_id,
          })}
        >
          Partner Info
        </NavLink>
        <NavLink
          exact
          to={generatePath(ROUTES.PARTNERS_ASSESSMENTS_PATH, {
            record_version_id: props.recordVersionId,
            workspace_id,
          })}
        >
          Assessments
        </NavLink>
        <NavLink
          exact
          to={generatePath(ROUTES.PARTNERS_DOCUMENTS_PATH, {
            record_version_id: props.recordVersionId,
            workspace_id,
          })}
        >
          Documents
        </NavLink>
      </ModuleTabs>
      {recordVersion && (
        <CommentsSlideMenu
          renderCommentsButton
          globalID={recordVersion.global_id}
          recordID={recordVersion.record_id}
          taskableType="Record"
          uncompletedCommentsCount={recordVersion.uncompleted_comments_count}
        />
      )}
    </Flex>
  );
}

export default observer(PartnerTabs);
